module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Tools/Link-3ab0118d6d58d396244a66b2e466e25e.svg";